import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import Demo from "./pages/Demo";
import Layout from "./components/Layout";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import LegalPage from "./pages/LegalPage";
import Home from "./pages/Home";
import FieldTesterPro from "./pages/FieldTesterPro";
import WhatIsASDRY from "./pages/what-is-asdry";
import Api from "./pages/Api";
import Business from "./pages/Business";
import ParkrunFeedback from "./pages/ParkrunFeedback";
import Beta from "./pages/Beta";
import Updates from "./pages/Updates";

function RouteScrollManager() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      target?.scrollIntoView();
      return;
    }

    if (navigationType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname, hash, navigationType]);

  return null;
}

export default function App() {
  return (
    <Layout>
      <RouteScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/field-tester-pro" element={<FieldTesterPro />} />
        
        <Route path="/business" element={<Business />} />
        <Route path="/beta" element={<Beta />} />
        <Route path="/updates" element={<Updates />} />
        <Route path="/demo" element={<Demo />} />

        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />

        <Route path="/about" element={<About />} />
        
        <Route path="/api" element={<Api />} />

        <Route path="/what-is-asdry" element={<WhatIsASDRY />} />

        <Route path="/contact" element={<Contact />} />

        <Route path="/parkrun-feedback" element={<ParkrunFeedback />} />

        <Route
          path="/terms"
          element={
            <LegalPage
              type="terms"
              title="Terms & Conditions"
            />
          }
        />

        <Route
          path="/privacy"
          element={
            <LegalPage
              type="privacy"
              title="Privacy Policy"
            />
          }
        />

        <Route
          path="/cookies"
          element={
            <LegalPage
              type="cookies"
              title="Cookies"
            />
          }
        />
      </Routes>
    </Layout>
  );
}
